import type { AnyResolvedField } from '#layers/data-model/types/schema/resolved-schema';
import { getPrimitiveFieldPresentationDefaults, getRelationFieldDisplayDefaults } from '#layers/data-model/constants/fields';
import { resolveFieldPresentationBlock } from '#layers/data-model/utils/fields/presentation';

export interface FieldDisplayBlockOptions {
	block: string;
	props: Record<string, unknown>;
}

/**
 * Resolve the display block ID and user-configured props for a field.
 *
 * Field-level `displayId` is treated as the selected display block. Default
 * display props only apply when that selected block is the default block for the field.
 * Field-level `displayOptions` are passed through as props, along with `fieldId`.
 */
export function getFieldDisplayBlockOptions(field: AnyResolvedField): FieldDisplayBlockOptions {
	const isRelation = 'oppositeCollectionId' in field;
	const defaultDisplay = isRelation
		? getRelationFieldDisplayDefaults(field)
		: getPrimitiveFieldPresentationDefaults(field.type).display;

	const display = resolveFieldPresentationBlock(defaultDisplay, field.meta?.displayId, {
		fieldId: field.id,
		...field.meta?.displayOptions,
	});

	return {
		block: display.block,
		props: display.props ?? {},
	};
}
